<script setup lang="ts">
import { computed, inject, ref, watch } from 'vue';
import { useStore } from '@/stores/main';
import { useIonRouter } from '@ionic/vue';

const props = defineProps({
  index: Number,
  data: Object,
  name: String,
  color: String,
  expand: {
    type: Boolean,
    default: false,
  },
  vertical: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits<{
  (e: 'picked'): void;
  (e: 'improve', value: string): void;
}>();

const store = useStore();
const router = useIonRouter();

const questionData = inject<any>('questionData');

// Local optimistic state for instant feedback
const localSelected = ref<boolean>(false);

const profileValue = computed(() => store.getProfileValue(props.name || ''));
const isChecked = computed(() => profileValue.value);

// Reset local state when store value changes to a different answer
watch(() => store.getProfileValue(props.name || ''), (newVal) => {
  if (newVal != props.data?.value) {
    localSelected.value = false;
  }
}, { immediate: true });

// Optimistic model value - use local state or store value
const optimisticModelValue = computed(() => {
  if (localSelected.value) {
    return props.data?.value;
  }
  return isChecked.value;
});

// Handle click with optimistic update
const handleSelect = () => {
  localSelected.value = true;
  emit('picked');
  // Clear local state after store updates
  setTimeout(() => {
    localSelected.value = false;
  }, 1500);
};
</script>

<template>
  <li class="list-none">
    <b-radio
      :name="name"
      :value="data?.value"
      :color="color"
      :label="data?.label"
      :label-name="`${name}-${index}-label`"
      @change="handleSelect"
      :model-value="optimisticModelValue"
      class="mx-4"
      :vertical="vertical"
    />
  </li>
</template>
